import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

/**
 * Magic-link sign-in, used by the demo game.
 *
 * Exchanges the token in the URL for a session cookie, then continues to
 * wherever `next` points.
 */
export function Join({ onSignedIn }: { onSignedIn?: () => void }) {
  const { token } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) return;
    void fetch(`/api/auth/join/${token}`)
      .then(async (res) => {
        if (!res.ok) {
          setError("This link is not valid, or it has expired.");
          return;
        }
        onSignedIn?.();
        navigate(params.get("next") ?? "/", { replace: true });
      })
      .catch(() => setError("Could not reach the server."));
  }, [token, params, navigate, onSignedIn]);

  return (
    <p style={{ color: error ? "#c62828" : "#666" }}>{error ?? "Signing you in…"}</p>
  );
}
